import { GRAPHQL_AUTH_MODE } from '@aws-amplify/auth';
export { GRAPHQL_AUTH_MODE };
export var GraphQLAuthError;
(function (GraphQLAuthError) {
  GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
  GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
  GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
  GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
  GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})(GraphQLAuthError || (GraphQLAuthError = {}));